import qs from 'qs';
import axios from 'axios';
import StorageManager from 'src/managers/StorageManager';

export default class AuthManager {
  constructor() {
    this.storage = new StorageManager();
  }

  login(username, password, namespace) {
    return axios.post('/oauth/token', {
      namespace: namespace,
      username: username,
      password: password,
      client_id: process.env.OAUTH.CLIENT_ID,
      grant_type: process.env.OAUTH.GRANT_TYPE,
    })
    .then((response) => {
      // save credential
      return this.storage.setCredential(response.data, namespace);
    }).then((data) => {
      // fetch current user information
      return axios.get(`/api/user`, {
        headers: {
          Authorization: `Bearer ${data.credential.access_token}`,
        },
      });
    }).then((response) => {
      // save lang
      this.storage.setLang(response.data.lang, namespace);

      // save current user's team information
      return this.storage.setTeam(response.data.team);
    });
  }

  logout(namespace) {
    // request logout
    axios.post('/api/user/logout');

    // remove credential
    return this.storage.removeCredential(namespace);
  }

  checkAuth(namespace) {
    return this.storage.getCredential(namespace).then((credential) => {
      if (credential) {
        if (this.isValidCredential(credential)) {
          return credential;
        } else {
          // credential expired, get new one
          return this.refreshAuth(credential);
        }
      } else {
        // credential not found
        throw new Error();
      }
    });
  }

  refreshAuth(oldCredential) {
    return axios.post('/oauth/token', {
      refresh_token: oldCredential.refresh_token,
      client_id: '',
      grant_type: 'refresh_token',
    })
    .then((response) => {
      return this.storage.setCredential(response.data, oldCredential.namespace);
    })
    .then(() => {
      return this.getAccessToken(oldCredential.namespace);
    });
  }

  isValidCredential(credential) {
    const now = new Date();
    const expired = new Date(credential.created_at + (credential.expires_in * 1000));

    // compare current time with expired time
    if (now.getTime() > expired.getTime()) {
      // credential expired
      return false;
    }
    return true;
  }

  getAccessToken(namespace) {
    return this.storage.getCredential(namespace);
  }

  getLoggedInTeams() {
    return this.storage.getTeams();
  }

  getFormAuthorizeURL(queryStringObject) {
    return `${process.env.BASE_URL}/api/oauth/authorize?${qs.stringify(queryStringObject)}`;
  }

  isOauthFromOtherService(queryStringObject) {
    return ('redirect_uri' in queryStringObject);
  }
}



// WEBPACK FOOTER //
// ./src/managers/AuthManager.js